import React from 'react'
import {
  RealEstateDataHeaderData,
  RealEstateDataPage,
  RealEstateDataPageComponent,
  RealEstateDataPageComponentData,
} from 'types'
import Searcher from '@components/search/1'
interface ExternalProps {
  pages: RealEstateDataPage[]
  data: RealEstateDataHeaderData
  is_bottom_searcher: boolean
}

type CombinedProps = RealEstateDataPageComponentData & ExternalProps

const Searcher2 = (props: CombinedProps) => {
  return (
    <Searcher
      is_short={true}
      backgroundSecondary={true}
      locationsAdv={true}
      {...props}
      is_bottom_searcher={true}
    />
  )
}

export default Searcher2
